import { KeyboardEvent } from "react";
import { setInputValue } from "./setInputValue";

export const applyMaskFunctionFactory = (maskFunction: (value: string) => string) => {
  return (event: KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const input = event.currentTarget;
    setInputValue(input, maskFunction(input.value));
  };
};
